export const dateFormatter = (utcDate: string): string | null => {
    if (!utcDate || utcDate === "0001-01-01T00:00:00Z") {
        return null; // or any default value you prefer for invalid dates
    }

    const articleDateObj = new Date(utcDate);
    const options: Intl.DateTimeFormatOptions = {
        month: "short",
        day: "numeric",
        year: "numeric",
    };
    return articleDateObj.toLocaleString("en-US", options);
};
